import React from 'react';
import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'

class date extends React.Component {
    // display current date
    render() {
        return (
            <Container>
                <Row>
                    <Col>
                        <h1 style = {{display: 'flex', justifyContent: 'center'}}>{new Date().toLocaleDateString()}</h1>
                    </Col>
                </Row>
            </Container>
        );
    }
}
export default date